import { isBatchDiscountModal } from "@/atoms/item/is-batch-discount-modal";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { FormEvent, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Button, Label, Modal, TextInput } from "flowbite-react";
import { itemService } from "@/services/item-service";
import { UpdateItemDiscountsPayload } from "@/types/payload/update-item-discounts-payload";

export const BatchDiscountModal = () => {
  const [modal, setModal] = useRecoilState(isBatchDiscountModal);
  const [discountRate, setDiscountRate] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const setToast = useSetRecoilState(toastState);

  const handleClose = () => {
    setModal({ ...modal, isOpen: false });
    setDiscountRate(0);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (modal.selectedIds.length === 0) {
      setToast({
        show: true,
        messages: ["선택된 상품이 없습니다."],
      });
      return;
    }

    setIsLoading(true);

    try {
      const updateItemDiscountsPayload: UpdateItemDiscountsPayload = {
        ids: modal.selectedIds,
        discountRate: discountRate,
      };

      const updateDiscountsResponse = await itemService.updateDiscounts(
        updateItemDiscountsPayload
      );

      if (updateDiscountsResponse) {
        setToast({
          show: true,
          messages: ["변경된 할인율이 반영되었습니다."],
        });

        handleClose();

        // 성공 콜백 호출
        if (modal.onSuccess) {
          modal.onSuccess();
        }
      }
    } catch (error) {
      console.error(error);
      setToast({
        show: true,
        messages: ["할인율 적용 중 오류가 발생했습니다."],
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={modal.isOpen} onClose={handleClose} size="md">
      <Modal.Header>상품 일괄 할인</Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="space-y-4">
            <div>
              <Label htmlFor="discountRate" value="할인율 (%)" />
              <TextInput
                id="discountRate"
                type="number"
                min="0"
                max="100"
                value={discountRate}
                onChange={(e) => setDiscountRate(Number(e.target.value))}
                onFocus={(e) => e.currentTarget.select()}
                required
              />
            </div>
            <p className="text-sm text-gray-500">
              선택된 상품 개수: {modal.selectedIds.length}개
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            color={ButtonColor.PRIMARY}
            disabled={isLoading}
          >
            {isLoading ? "처리 중..." : "할인 적용"}
          </Button>
          <Button color={ButtonColor.TRANSPARENT_OUTLINE} onClick={handleClose}>
            취소
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
